import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../Store/actions";
import { Step, Stepper, StepLabel } from "@mui/material/";
import styles from "./styles";
import { useTranslation } from "react-i18next";
import DoneIcon from "@mui/icons-material/Done";

import StepConnector, {
    stepConnectorClasses,
} from "@mui/material/StepConnector";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            background: theme.palette.border.primary,
        },
    },
    // Future proof
    // [`&.${stepConnectorClasses.completed}`]: {
    //     [`& .${stepConnectorClasses.line}`]: {
    //         background: theme.palette.border.primary,
    //     },
    // },
    // [`& .${stepConnectorClasses.line}`]: {
    //     height: 3,
    //     border: 0,
    //     backgroundColor: theme.palette.grey[800],
    //     borderRadius: 1,
    // },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.background.mediumBackground,
    zIndex: 1,
    color: theme.palette.background.lightBackground,
    width: 70,
    height: 50,
    display: "flex",
    borderRadius: "10%",
    justifyContent: "center",
    alignItems: "center",
    ...(ownerState.active && {
        border: `1px solid ${theme.palette.border.primary}`,
        background: theme.palette.border.lightBackground,
    }),
    ...(ownerState.isMandatory && {
        color: theme.palette.iconsColor.primary,
    }),
    // future proof
    // ...(ownerState.completed && {
    //     background: theme.palette.iconsColor.primary,
    // }),
}));

function ColorlibStepIcon(props) {
    const { assetDetails } = useSelector((state) => state);
    const { steps, stepsCompleted } = assetDetails;
    const { active, completed, className, icon } = props;

    const step = steps[icon - 1];

    return (
        <ColorlibStepIconRoot
            ownerState={{
                completed,
                active,
                isMandatory: step.isMandatory,
            }}
            className={className}
        >
            {stepsCompleted[icon - 1] ? (
                <DoneIcon sx={styles.completed} />
            ) : (
                step.icon
            )}
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
};

export default function CustomizedSteppers() {
    const dispatch = useDispatch();

    const { assetDetails } = useSelector((state) => state);

    const { steps, activeStep, exclusionReasonTypeId } = assetDetails;

    const { t } = useTranslation();
    // When step is added call render again
    useEffect(() => {}, [steps, exclusionReasonTypeId]);

    const hdlNext = (stepNo) => () => {
        // if over last step
        if (stepNo + 1 > steps.length) return;

        dispatch(actions.assetDetails.create.set({ activeStep: stepNo }));
    };

    return (
        <>
            <Stepper
                alternativeLabel
                activeStep={activeStep}
                connector={<ColorlibConnector />}
                sx={styles.stepper}
            >
                {steps.map((step, index) => {
                    /** On every thirdchild hideBorder  */
                    const isThirdChild = index % 3 === 0;
                    return (
                        <Step
                            sx={isThirdChild ? styles.hideBorder : null}
                            key={`${step.label}-${index}`}
                            onClick={hdlNext(index)}
                        >
                            <StepLabel StepIconComponent={ColorlibStepIcon}>
                                {t(step.label)}
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            {steps[activeStep] && steps[activeStep].component}
        </>
    );
}
